export default "__VITE_ASSET__5e95754d__"